import { Injectable } from '@angular/core';
import { SearchProjectModel } from 'src/app/shared/model/SearchProject.model';

@Injectable({
  providedIn: 'root'
})
export class SearchParameterService {
  private _searchModel: SearchProjectModel;

  constructor() { }

  StoreSearchParameter(searchModel: SearchProjectModel) {
    this._searchModel = searchModel;
  }

  ReadStoredSearchParameter(): SearchProjectModel {
    return this._searchModel;
  }
}
